import {Api, Method} from "../../api/api";
import {showToast} from "../../toast";

// TODO: Добавить типы

const serviceCheckboxTypes = [`telegram`, `taskroom`, `email`];
const SERVICE_CHECKBOX_NAME: string = `service-notification`;

class Notifications {
  private readonly formElement: HTMLFormElement;
  private readonly serviceCheckboxElements: HTMLInputElement[];
  private readonly checkboxElements: HTMLInputElement[];
  private readonly actionUrl: string;

  private api = new Api();

  private state: Record<string, boolean> = {};

  constructor(selector: string) {
    this.formElement = document.querySelector(selector)!;
    this.serviceCheckboxElements = Array.from(this.formElement.querySelectorAll(
      `input[type="checkbox"][data-checkbox-name="${SERVICE_CHECKBOX_NAME}"]`));

    this.checkboxElements = Array.from(this.formElement.querySelectorAll(`input[type="checkbox"]`));
    this.actionUrl = this.formElement.action;

    this.updateState();

    this.onFormChange = this.onFormChange.bind(this);
  }

  init() {
    this.formElement.addEventListener(`change`, this.onFormChange);
  }

  private getFormData(): FormData {
    return new FormData(this.formElement);
  }

  // Добавляем класс главному чекбоксу если хоть один малый чекбокс активен
  private updateServiceCheckboxClass(type: string | undefined, mainCheckbox: HTMLInputElement) {
    const hasSomeChecked: boolean = this.checkboxElements
      .some((checkbox) => checkbox.dataset.type === type && checkbox.checked);

    if (hasSomeChecked) {
      mainCheckbox.classList.add(`checkbox__input--has-active`);
    } else {
      mainCheckbox.classList.remove(`checkbox__input--has-active`);
    }
  }

  private changeServiceCheckbox(serviceType: string | undefined): void {
    if (!serviceType) {
      throw new Error(`Service type is undefined`);
    }

    // здесь выключаю главный чекбокс если хоть один малый чекбокс не выбран
    const isCheckedAll: boolean = this.checkboxElements
      .filter((checkbox) => checkbox.dataset.type === serviceType)
      .every((checkbox) => checkbox.checked);

    for (const checkboxElement of this.serviceCheckboxElements) {
      if (checkboxElement.dataset.serviceName === serviceType) {
        checkboxElement.checked = isCheckedAll;

        this.updateServiceCheckboxClass(serviceType, checkboxElement);
        break;
      }
    }
  }

  // Изменение чекбоксов относящихся к определенному сервисному, в том числе
  private changeCheckboxesOnServiceCheckbox(target: HTMLInputElement, serviceType: string): void {
    this.checkboxElements.forEach((checkboxElement) => checkboxElement.dataset.type === serviceType &&
      (checkboxElement.checked = target.checked));
  }

  private updateState(): void {
    this.checkboxElements.forEach((checkboxElement) => this.state[checkboxElement.value] = checkboxElement.checked);
  }

  private returnPreviousState(): void {
    this.checkboxElements.forEach((checkboxElement) => (checkboxElement.checked = this.state[checkboxElement.value]));
  }

  private async post(): Promise<{status: number; answer: string}> {
    return await this.api.customQuery(this.actionUrl, {method: Method.POST, query: this.getFormData()});
  }

  async onFormChange(evt: Event): Promise<void> {
    const target = evt.target as HTMLInputElement;

    if (target.dataset.serviceName && serviceCheckboxTypes.includes(target.dataset.serviceName)) {
      this.changeCheckboxesOnServiceCheckbox(target, target.dataset.serviceName);
      this.changeServiceCheckbox(target.dataset.serviceName);
    } else {
      this.changeServiceCheckbox(target.dataset.type);
    }

    const {status, answer} = await this.post();

    if (status === 200) {
      this.updateState();
    } else {
      this.returnPreviousState();
      showToast(answer);
    }
  }
}

export {Notifications};
